function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z",
  fill: "#5822f6",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z",
  fill: "#eee8fe",
  fillOpacity: 0.1,
  transform: "rotate(30 64 64)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z",
  fill: "#eee8fe",
  fillOpacity: 0.1,
  transform: "rotate(60 64 64)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z",
  fill: "#eee8fe",
  fillOpacity: 0.1,
  transform: "rotate(90 64 64)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z",
  fill: "#dfd5fd",
  fillOpacity: 0.19,
  transform: "rotate(120 64 64)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z",
  fill: "#d0c1fc",
  fillOpacity: 0.28,
  transform: "rotate(150 64 64)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z",
  fill: "#c0acfc",
  fillOpacity: 0.38,
  transform: "rotate(180 64 64)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z",
  fill: "#b299fb",
  fillOpacity: 0.46,
  transform: "rotate(210 64 64)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z",
  fill: "#a385fa",
  fillOpacity: 0.55,
  transform: "rotate(240 64 64)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z",
  fill: "#9472f9",
  fillOpacity: 0.64,
  transform: "rotate(270 64 64)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z",
  fill: "#855df8",
  fillOpacity: 0.73,
  transform: "rotate(300 64 64)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z",
  fill: "#764af8",
  fillOpacity: 0.82,
  transform: "rotate(330 64 64)"
}), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  values: "0 64 64;30 64 64;60 64 64;90 64 64;120 64 64;150 64 64;180 64 64;210 64 64;240 64 64;270 64 64;300 64 64;330 64 64",
  calcMode: "discrete",
  dur: "1080ms",
  repeatCount: "indefinite"
}));

var SvgLoadingIconSmall = function SvgLoadingIconSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoadingIconSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loading-icon-small.70df7e22.svg";
export { ForwardRef as ReactComponent };